import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BurgerButtonWrapperComponent } from '../burger-button-wrapper/burger-button-wrapper.component';

@Component({
    selector: 'app-top-button-wrapper',
    standalone: true,
    imports: [CommonModule, BurgerButtonWrapperComponent],
    templateUrl: './top-button-wrapper.component.html',
    styleUrls: ['./top-button-wrapper.component.scss'],
})
export class TopButtonWrapperComponent {}
